(function () {
    $.nette.ext('datagrid-filters', {
        complete: (xhr, status, settings) => {
            if (
                settings.url
                && (
                    settings.url.includes('resetFilter')
                    || settings.url.includes('hideColumn')
                    || settings.url.includes('showColumn')
                    || settings.url.includes('showAllColumns')
                    || settings.url.includes('showDefaultColumns')
                    || settings.url.includes('page')
                    || settings.url.includes('sort')
                    || settings.url.includes('submit')
                )) {
                initDatagridFilters();
            }

            window.zasIsPage.setPreviousPage();
        }
    });

    const DATAGRID_DEFAULT_SUBMIT_TIMEOUT = 2000;
    window.datagridSubmitTimeout = DATAGRID_DEFAULT_SUBMIT_TIMEOUT;

    // disable form submit on hitting enter in filters
    $(document).on('keydown', 'input[data-autosubmit]', function (e) {
        const code = e.which || e.keyCode || 0;
        if (code === 13) {
            e.preventDefault();
            e.stopPropagation();
            window.datagridSubmitTimeout = 0;
        }
    });

    // Rewrite ublaboo datagrid default settings for filter autosubmit and set timeout to 2 secs
    $(document).on('keyup', 'input[data-autosubmit]', function (e) {
        const code = e.which || e.keyCode || 0;
        if ((code !== 13) && ((code >= 9 && code <= 40) || (code >= 112 && code <= 123))) {
            return;
        }

        clearTimeout(window.datagrid_autosubmit_timer);

        const filterInput = $(this);

        return window.datagrid_autosubmit_timer = setTimeout((function () {
            return function () {
                window.datagridSubmitTimeout = DATAGRID_DEFAULT_SUBMIT_TIMEOUT;
                return filterInput.closest('form').first().submit();
            };
        })(this), window.datagridSubmitTimeout);
    });
}).call(this);

const initDatagridFilters = function () {
    $('.datagrid-content tr:not(.row-group-actions) select.select2').select2()
        .on('change', function () {
            let selectedOptions = $(this).find(':selected');
            let displayHtml = '';
            let count = selectedOptions.length;

            selectedOptions.each(function (index) {
                if (index < 1) {
                    displayHtml += '<span class="select2-selection__choice">' + $(this).text() + '<span class="select2-selection__choice__remove" role="presentation">×</span></span>';
                }
            });

            if (count > 1) {
                displayHtml += '<span class="ml-2"> +' + (count - 1) + '</span>';
            }

            let rendered = $(this).next('.select2-container').find('.select2-selection__rendered');
            rendered.html(displayHtml);

            rendered.find('.select2-selection__choice__remove').on('click', function (e) {
                e.stopPropagation();
                let value = $(this).parent().text().slice(0, -1);
                let option = $(this).closest('.select2-container').prev('select').find('option').filter(function () {
                    return $(this).text() === value;
                });
                option.prop('selected', false).trigger('change');
            });
        });


    $('[data-provide=datepicker]').each(function () {
        $(this).datepicker({
            dateFormat: 'dd.mm.yy',
        });
    });
    // Fix for old datagrid vs. bootstrap v5. Could be deleted when grid is updated.
    // In bootstrap v5 attribute `data-toggle` has been renamed to `data-bs-toggle`
    $('[data-toggle="dropdown"]').each(function () {
        this.setAttribute('data-bs-toggle', 'dropdown');
        this.removeAttribute('data-toggle', 'dropdown');
    });
    $('.select2-multiple').each(function () {
        $(this).attr('multiple', 'multiple');
        $(this).select2();
    });
}

// init select2 on filters (not group actions) after whole datagrid is rendered
// init datepicker and dropdown (data-bs-toggle)
$(window).on('load', function () {
    initDatagridFilters();
});
